import styled from 'styled-components';
import Bcc001 from 'dc/Bcc001';
import Ico24 from 'dc/Ico24';

export const Wrapper = styled.div`
  position: relative;
  height: 28px;
  width: 100%;
`;

export const ButtonCounter = styled(Bcc001)`
  background-color: #00ab97;
  vertical-align: top;
  position: absolute;
  padding: 0;
  left: ${props => `${props.position}px`};
`;

type ArrowProps = { $expanded: boolean };

export const Arrow = styled(Ico24)<ArrowProps>`
  right: 0;
  position: absolute;
  transition-duration: 0.5s;
  transition-property: transform;
  ${props => (props.$expanded ? 'transform: rotate(180deg);' : null)};
`;
